<div class="d-flex justify-content-between align-items-center mb-2">
  <div class="title">
    <strong>Shipping and Customs Documents</strong>
  </div>
</div>

<div class="files">
  <div class="actions">
    <button (click)="openFileModal('')" class="btn btn-link text-capitalize" title="See all files">
      <i class="fa fa-plus"></i>
      See all files
    </button>
    <button (click)="openFileModal('PACKING_LIST')" class="btn btn-link text-capitalize" title="Upload Packing List">
      <i class="fa fa-plus"></i>
      Upload Packing List
    </button>
    <button
      (click)="openFileModal('BILL_OF_LADING')"
      class="btn btn-link text-capitalize"
      title="Upload Bill Of Lading"
    >
      <i class="fa fa-plus"></i>
      Upload Bill Of Lading
    </button>
    <button
      (click)="openFileModal('IMPORTER_SECURITY_FILLING')"
      class="btn btn-link text-capitalize"
      title="Upload Importer Security Filling"
    >
      <i class="fa fa-plus"></i>
      Upload ISF
    </button>
    <button
      (click)="openFileModal('INSPECTION_DOCUMENT')"
      class="btn btn-link text-capitalize"
      title="Upload Inspection Document"
    >
      <i class="fa fa-plus"></i>
      Upload Inspection Document
    </button>
  </div>

  <ngx-title-divider title="Files" [small]="true"></ngx-title-divider>

  <div class="file" *ngFor="let file of purchaseOrder?.files; let $index = index">
    <div class="row" *ngIf="file.shipment_file_info">
      <div class="col-md-12">
        <div
          class="filename"
          [matTooltip]="'Uploaded at ' + (file.created_at | date: 'MM/dd/yyyy':'utc') + ' by ' + file.created_by_name"
        >
          <a ngxFilesPreview [fileName]="file.file_name" [fileId]="file.file_id">
            <span *ngIf="file?.label">{{ file?.label }} - </span>
            {{ file.file_name }}
          </a>
        </div>
        <div class="file-info">
          {{ getShipmentDetailsText(file?.shipment_file_info?.shipment_tracking_id) }}
        </div>
      </div>
    </div>
  </div>
  <ng-template #noFiles>
    <p class="m-0">There are no Shipping or Customs files yet.</p>
  </ng-template>
</div>
